export const employeeDistributionColumnWidths = {
  selection: '4%',
  id: '7%',
  taskType: '7%',
  requiredEmployees: '4%',
  name: '9%',
  departmentName: '8%',
  creationDate: '9%',
  taskStatus: '7%',
  plannedStartDate: '8%',
  plannedEndDate: '8%',
  employees: '18%',
  manualAssign: '5%'
} as const;

export const employeeAssignmentResultColumnWidths = {
  taskId: '12%',
  taskType: '12%',
  name: '14%',
  status: '14%',
  employees: '20%',
  note: '28%'
} as const;

export const employeeAssignmentErrorColumnWidths = {
  taskId: '15%',
  taskType: '25%',
  error: '60%'
} as const;
